<template>
  <div class="dashboard vertical-center">
    <!--
        <el-select style="margin-right: 30px" v-model="value" filterable placeholder="请选择项目">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value" :index="item.label">
          </el-option>
        </el-select>
        -->
    <span class="welcome-msg">
      欢迎使用研和智能内部系统
    </span>
  </div>
</template>

<script>
    export default {
        name: 'Dashboard',
        data() {
            return {
                options: [{
                    value: 'watch',
                    label: '手表'
                }, {
                    value: 'box',
                    label: '药盒子'
                }],
                value: ''
            }
        }
    }
</script>

<style>

  .welcome-msg {
    text-align: center;
    font-size: 40px;
    width: 100%;
    height: 200px;
  }

  .dashboard {

    width: 100%;
    height: 100%;
    background-color: white;
  }

</style>
